// extracted by mini-css-extract-plugin
module.exports = {"primary":"contact-module--primary--3k7jl","secondary":"contact-module--secondary--1hmP3"};